import React from "react";
import InputKeyValue from "../../shared/InputKeyValue";
import { t } from "../../../../i18n";
import CustomButton from "../../shared/CustomButton";
import { CircleInfo } from "../../normalizer";

const UserPasswordEdit = (props) => {
  const { onEditPasswordSubmit, onEditPasswordCancel, onPasswordSuccess, onPasswordFailure } = props;
  const [isValid, setIsValid] = React.useState(false);
  const [currentError, setCurrentError] = React.useState(null);
  const [newPasswordError, setNewPasswordError] = React.useState(null);
  const [confNewPasswordError, setConfNewPasswordError] = React.useState(null);

  const handlePasswordChange = (e) => {
    const { currentPassword, newPassword, confNewPassword } = e.currentTarget;
    let isvalid = true;
    /* lets instead create a messate for each validation error*/
    const errors = [];
    /* The password is less than 8 characters;*/
    if (newPassword.value.length < 8) {
      errors.push("A palavra-passe deve ter pelo menos 8 caracteres");
    }
    /* The password must contain upper and lower case letters;*/
    if (!newPassword.value.match(/[a-z]/) || !newPassword.value.match(/[A-Z]/)) {
      errors.push("A palavra-passe deve conter letras maiúsculas e minúsculas");
    }
    /*The password must include numbers;*/
    if (!newPassword.value.match(/\d/)) {
      errors.push("A palavra-passe deve conter pelo menos um número");
    }
    /* The password must include special characters;*/
    if (!newPassword.value.match(/[!@#$%^&*(),.?":{}|<>]/)) {
      errors.push("A palavra-passe deve conter pelo menos um caracter especial");
    }
    /*The new password is equal to the current password;*/
    if (newPassword.value === currentPassword.value) {
      errors.push("A nova palavra-passe não pode ser igual à palavra-passe atual");
    }
    
    if (errors.length > 0) {
      setNewPasswordError(errors);
      isvalid = false;
    } else {
      setNewPasswordError(null);
    }

    if (newPassword.value !== confNewPassword.value) {
      setConfNewPasswordError(["As palavras-passe não coincidem"]);
      isvalid = false;
    } else {
      setConfNewPasswordError(null);
    }
    setIsValid(isvalid);

  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { currentPassword, newPassword, confNewPassword } = e.target;

    if (
      newPassword.value !== "" &&
      newPassword.value === confNewPassword.value
    ) {
      onEditPasswordSubmit(
        {
          user: {
            current_password: currentPassword.value,
            password: newPassword.value,
            password_confirmation: confNewPassword.value,
          },
        },
        () => {
          onPasswordSuccess && onPasswordSuccess();
        },
        (errors) => {
          onPasswordFailure && onPasswordFailure(Array.isArray(errors) ? errors : []);
        },
      );
    }
  };

  return (
    <form
        onSubmit={handleSubmit}
        onChange={handlePasswordChange}
        id="user-password-edit-form"
        className="user-info-edit"
      >
        <div className="user-password-container">
          <div className="user-password-container-header">
            <h5 className="user-password-container-title">
              {t("gamification2026.profile.change-password")}
            </h5>
            <div className="user-password-container-msg">
              {t("gamification2026.profile.change-password-msg")}
            </div>
          </div>
          <div className="user-password-container-form">
            <div className="user-password-container-form-row">
              <InputKeyValue
                title={t("gamification2026.profile.current-password")}
                type="password"
                error={currentError}
                placeholder={t(
                  "gamification2026.profile.current-password-placeholder",
                )}
                name="currentPassword"
              />
            </div>
            <div className="user-password-container-form-row">
              <InputKeyValue
                title={t("gamification2026.profile.new-password")}
                type="password"
                error={newPasswordError}
                placeholder={t(
                  "gamification2026.profile.new-password-placeholder",
                )}
                name="newPassword"
              />
            </div>
            <div className="user-password-container-form-row">
              <InputKeyValue
                title={t("gamification2026.profile.confirm-password")}
                type="password"
                error={confNewPasswordError}
                placeholder={t(
                  "gamification2026.profile.confirm-password-placeholder",
                )}
                name="confNewPassword"
              />
            </div>
          </div>
        </div>
        <div className="user-password-requirements">
          <CircleInfo
            className="user-password-requirements-icon"
            width={24}
            height={24}
            fill={"#2261D9"}
            stroke={"white"}
          />
          <div className="user-password-requirements-content">
            <h5 className="user-password-requirements-header">
              Requisitos da palavra chave
            </h5>
            <div className="user-password-requirements-text">
              <p>8 ou mais caracteres;</p>
              <p>Incluir letras maiúsculas e minúsculas;</p>
              <p>Incluir números;</p>
              <p>Incluir caracteres especiais;</p>
            </div>
          </div>
        </div>
        <div className="user-password-container-buttons">
          <CustomButton
            secondary
            onClick={onEditPasswordCancel}
            className="user-password-container-buttons-cancel"
          >
            {t("gamification2026.profile.cancel")}
          </CustomButton>
          <CustomButton
            className="user-password-container-buttons-change"
            disabled={!isValid}
            type={"submit"}
            form={"user-password-edit-form"}
          >
            {t("gamification2026.profile.change")}
          </CustomButton>
        </div>
      </form>
  );
};

export default UserPasswordEdit;
